import { MapPin, Phone, Clock } from "lucide-react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="bg-slate-950 text-slate-300 border-t border-slate-900">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <h3 className="text-white text-lg font-bold mb-4">
              M Pomp <span className="text-amber-500">Multiservice</span>
            </h3>
            <p className="text-sm leading-relaxed mb-4 text-slate-400">
              Uw betrouwbare partner voor installatietechniek en loodgieterswerk. Vakmanschap en persoonlijke service staan bij mij centraal.
            </p>
          </div>

          {/* Contact Details */}
          <div>
            <h3 className="text-white text-lg font-bold mb-4">Contactgegevens</h3>
            <ul className="space-y-3">
              <li className="flex items-start gap-3">
                <MapPin className="h-5 w-5 text-amber-500 shrink-0 mt-0.5" />
                <span>IJsselstraat 10<br />1972 WD IJmuiden</span>
              </li>
              <li>
                <button
                  onClick={() => window.location.href = 'tel:+31625007564'}
                  className="flex items-center gap-3 hover:text-amber-500 transition-colors bg-transparent border-none cursor-pointer p-0 text-left"
                >
                  <Phone className="h-5 w-5 text-amber-500 shrink-0 hover:text-amber-400" />
                  <span className="font-bold">06 25007564</span>
                </button>
              </li>
            </ul>
          </div>

          {/* Opening Hours */}
          <div>
            <h3 className="text-white text-lg font-bold mb-4">Openingstijden</h3>
            <ul className="space-y-2">
              <li className="flex items-start gap-3">
                <Clock className="h-5 w-5 text-amber-500 shrink-0 mt-0.5" />
                <div>
                  <p className="font-medium text-white">7 Dagen per week</p>
                  <p>07:00 - 19:00 uur</p>
                </div>
              </li>
            </ul>
            <div className="mt-4 p-3 bg-slate-900 rounded border border-slate-800">
              <p className="text-xs text-amber-500 font-semibold uppercase tracking-wide">Storingsdienst</p>
              <p className="text-sm">Bij spoed direct bereikbaar.</p>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white text-lg font-bold mb-4">Snelle Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="hover:text-amber-500 transition-colors">Home</Link>
              </li>
              <li>
                <Link to="/diensten" className="hover:text-amber-500 transition-colors">Mijn Diensten</Link>
              </li>
              <li>
                <Link to="/contact" className="hover:text-amber-500 transition-colors">Contact Opnemen</Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-900 mt-12 pt-8 text-center text-sm text-slate-500">
          <p>&copy; {new Date().getFullYear()} M Pomp Multiservice. Alle rechten voorbehouden.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;